import(/* webpackMode: "eager" */ "/opt/render/project/src/src/app/support/page.js");
